import Api from "../api/api";

export default async ({ commentId, body }) => {
  const { data } = await Api.post(`comment/delete/${commentId}`, body);
  return data;
};
